import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';

import __DEPRECATED_defineResources from 'dpl/shared/fetching/deprecated/defineResources';
import { singleShelterResourceDefinition } from 'dpl/shared/utils/tptConnectResourceDefinitions';
import { pushParams } from 'dpl/actions/query_params';
import { DOG_ID } from 'dpl/constants/query_params';
import Details from 'dpl/shelter_search_results/components/Details';

function DetailsContainer(props) {
  return <Details {...props} />;
}

export default compose(
  __DEPRECATED_defineResources((_, props) => ({
    shelterData: singleShelterResourceDefinition(props.shelterId)
  })),
  connect(null, {
    onDogClick: dogId => pushParams({ [DOG_ID]: dogId }, { hash: true })
  })
)(DetailsContainer);
